// extracted by mini-css-extract-plugin
export default {"container":"o8fO","categoriesTitles":"enW5","title":"ZbgC","chosenTitle":"o4vQ"};